export default {
  getStringName(name) {
    return name || '-'
  }
}



// WEBPACK FOOTER //
// ./src/lib/getDataName.js